module.exports = {"152923001":"航空街道","152923002":"东风街道","152923100":"达来呼布镇","152923101":"东风镇","152923102":"哈日布日格德音乌拉镇","152923200":"赛汉陶来苏木","152923201":"马鬃山苏木","152923202":"苏泊淖尔苏木","152923203":"巴彦陶来苏木","152923204":"温图高勒苏木","152923205":"巴音陶海苏木"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152923.json
// module id = 586
// module chunks = 0